export default __webpack_public_path__ + "static/media/logo-black.6e3e050d.png";